import { createSlice } from '@reduxjs/toolkit';

import { failureAction, pendingAction, successAction } from './actionHandler';

const schemaSlice = createSlice({
  name: 'schema',
  initialState: null,
  reducers: {
    purgeCache: pendingAction(),
    purgeCacheSuccess: successAction(),
    purgeCacheFailure: failureAction(),
  },
});

export default schemaSlice.actions;
